import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListagemInadimplentes from "./components/ListagemInadimplentes/index";

function RelatorioInadimplentesPage() {
  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Inadimplentes",
      url: "/relatorios/financeiro/inadimplentes",
    },
  ]);

  return (
    <>
      <Container>
        <ListagemInadimplentes />
      </Container>
    </>
  );
}

export default RelatorioInadimplentesPage;
